// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type MediaAnalyticsQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
}>;


export type MediaAnalyticsQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { media: (
      { __typename?: 'AnalyticsMediaModel' }
      & Pick<PrivateSchemaTypes.AnalyticsMediaModel, 'averageEngagement' | 'playsCount' | 'impressionsCount' | 'playRate' | 'playTimeMinutes'>
      & { uniquePlaysCount: PrivateSchemaTypes.AnalyticsMediaModel['playsCount'] }
      & { impressionsByTimeUnit: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'day' | 'count'>
      )>, onlyEngagementsByTimeUnit: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'day' | 'count'>
      )> }
    ) }
  ) }
);

export type MediaAnalyticsOverviewQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  mediaOverviewFilter: PrivateSchemaTypes.AnalyticsMediaOverviewFilter;
}>;


export type MediaAnalyticsOverviewQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { media: (
      { __typename?: 'AnalyticsMediaModel' }
      & { mediaOverview?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'AnalyticsMediaOverviewModel' }
        & Pick<PrivateSchemaTypes.AnalyticsMediaOverviewModel, 'count'>
        & { items: Array<(
          { __typename?: 'AnalyticsMediaReportModel' }
          & Pick<PrivateSchemaTypes.AnalyticsMediaReportModel, 'id' | 'deletedAt' | 'resourceDeletedAt' | 'fileName' | 'resourceName' | 'avgEngagement' | 'playsCount' | 'impressionsCount' | 'playRate' | 'lastActivity' | 'createdAt'>
        )> }
      )> }
    ) }
  ) }
);

export type MediaAnalyticsCsvQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  mediaOverviewFilter: PrivateSchemaTypes.AnalyticsMediaOverviewFilter;
}>;


export type MediaAnalyticsCsvQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { media: (
      { __typename?: 'AnalyticsMediaModel' }
      & { mediaOverview?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'AnalyticsMediaOverviewModel' }
        & Pick<PrivateSchemaTypes.AnalyticsMediaOverviewModel, 'count'>
        & { items: Array<(
          { __typename?: 'AnalyticsMediaReportModel' }
          & Pick<PrivateSchemaTypes.AnalyticsMediaReportModel, 'id' | 'deletedAt' | 'resourceDeletedAt' | 'fileName' | 'resourceName' | 'avgEngagement' | 'playsCount' | 'impressionsCount' | 'playRate' | 'totalPlayTimeMinutes' | 'lastActivity' | 'uniquePlaysCount' | 'uniqueImpressionsCount' | 'createdAt'>
        )> }
      )> }
    ) }
  ) }
);


export const MediaAnalyticsDocument = gql`
    query mediaAnalytics($mainAnalyticsFilter: AnalyticsFilterWithGroups!) {
  analytics(filter: $mainAnalyticsFilter) {
    media {
      averageEngagement
      playsCount
      uniquePlaysCount: playsCount(onlyUnique: true)
      impressionsCount
      playRate
      playTimeMinutes
      impressionsByTimeUnit: impressionsByTimeUnit(unit: DAY, onlyEngagements: false) {
        day
        count
      }
      onlyEngagementsByTimeUnit: impressionsByTimeUnit(
        unit: DAY
        onlyEngagements: true
      ) {
        day
        count
      }
    }
  }
}
    `;

/**
 * __useMediaAnalyticsQuery__
 *
 * To run a query within a React component, call `useMediaAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAnalyticsQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *   },
 * });
 */
export function useMediaAnalyticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MediaAnalyticsQuery, MediaAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediaAnalyticsQuery, MediaAnalyticsQueryVariables>(MediaAnalyticsDocument, options);
      }
export function useMediaAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaAnalyticsQuery, MediaAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediaAnalyticsQuery, MediaAnalyticsQueryVariables>(MediaAnalyticsDocument, options);
        }
export type MediaAnalyticsQueryHookResult = ReturnType<typeof useMediaAnalyticsQuery>;
export type MediaAnalyticsLazyQueryHookResult = ReturnType<typeof useMediaAnalyticsLazyQuery>;
export type MediaAnalyticsQueryResult = Apollo.QueryResult<MediaAnalyticsQuery, MediaAnalyticsQueryVariables>;
export const MediaAnalyticsOverviewDocument = gql`
    query mediaAnalyticsOverview($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $mediaOverviewFilter: AnalyticsMediaOverviewFilter!) {
  analytics(filter: $mainAnalyticsFilter) {
    media {
      mediaOverview(overviewTableFilter: $mediaOverviewFilter) {
        items {
          id
          deletedAt
          resourceDeletedAt
          fileName
          resourceName
          avgEngagement
          playsCount
          impressionsCount
          playRate
          lastActivity
          createdAt
        }
        count
      }
    }
  }
}
    `;

/**
 * __useMediaAnalyticsOverviewQuery__
 *
 * To run a query within a React component, call `useMediaAnalyticsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAnalyticsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAnalyticsOverviewQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      mediaOverviewFilter: // value for 'mediaOverviewFilter'
 *   },
 * });
 */
export function useMediaAnalyticsOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MediaAnalyticsOverviewQuery, MediaAnalyticsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediaAnalyticsOverviewQuery, MediaAnalyticsOverviewQueryVariables>(MediaAnalyticsOverviewDocument, options);
      }
export function useMediaAnalyticsOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaAnalyticsOverviewQuery, MediaAnalyticsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediaAnalyticsOverviewQuery, MediaAnalyticsOverviewQueryVariables>(MediaAnalyticsOverviewDocument, options);
        }
export type MediaAnalyticsOverviewQueryHookResult = ReturnType<typeof useMediaAnalyticsOverviewQuery>;
export type MediaAnalyticsOverviewLazyQueryHookResult = ReturnType<typeof useMediaAnalyticsOverviewLazyQuery>;
export type MediaAnalyticsOverviewQueryResult = Apollo.QueryResult<MediaAnalyticsOverviewQuery, MediaAnalyticsOverviewQueryVariables>;
export const MediaAnalyticsCsvDocument = gql`
    query mediaAnalyticsCSV($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $mediaOverviewFilter: AnalyticsMediaOverviewFilter!) {
  analytics(filter: $mainAnalyticsFilter) {
    media {
      mediaOverview(overviewTableFilter: $mediaOverviewFilter) {
        items {
          id
          deletedAt
          resourceDeletedAt
          fileName
          resourceName
          avgEngagement
          playsCount
          impressionsCount
          playRate
          totalPlayTimeMinutes
          lastActivity
          uniquePlaysCount
          uniqueImpressionsCount
          createdAt
        }
        count
      }
    }
  }
}
    `;

/**
 * __useMediaAnalyticsCsvQuery__
 *
 * To run a query within a React component, call `useMediaAnalyticsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAnalyticsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAnalyticsCsvQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      mediaOverviewFilter: // value for 'mediaOverviewFilter'
 *   },
 * });
 */
export function useMediaAnalyticsCsvQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MediaAnalyticsCsvQuery, MediaAnalyticsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediaAnalyticsCsvQuery, MediaAnalyticsCsvQueryVariables>(MediaAnalyticsCsvDocument, options);
      }
export function useMediaAnalyticsCsvLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaAnalyticsCsvQuery, MediaAnalyticsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediaAnalyticsCsvQuery, MediaAnalyticsCsvQueryVariables>(MediaAnalyticsCsvDocument, options);
        }
export type MediaAnalyticsCsvQueryHookResult = ReturnType<typeof useMediaAnalyticsCsvQuery>;
export type MediaAnalyticsCsvLazyQueryHookResult = ReturnType<typeof useMediaAnalyticsCsvLazyQuery>;
export type MediaAnalyticsCsvQueryResult = Apollo.QueryResult<MediaAnalyticsCsvQuery, MediaAnalyticsCsvQueryVariables>;